/**
 * @author Eric Otto
 */

module.exports = {
    ajaxContainer: document.getElementById('ajax-wrapper'),
    loader: document.querySelector('.mdl-progress'),
    pageLang: 'de',
    ajaxUrl: location.pathname,
    links: document.querySelectorAll('a'),
    ajaxTimer: false,
    r: new XMLHttpRequest(),
    d: new FormData(),

    retinaImages: require('./retinaImages'),
    randomTeaser: require('./randomTeaser'),

    backLink: require('./backLink'),
    loadMore: require('./loadMore'),
    loadFilter: require('./loadFilter'),
    slider: require('./slider'),
    accordion: require('./accordion'),
    teamList: require('./teamList'),
    navigation: require('./navigation'),
    galleryDialog: require('./galleryDialog'),
    msnry: require('./msnry'),

    init: function ($container) {
        'use strict';


        const that = this;
        function load($url, $pushState) {
            if (!history.pushState) {
                return true;
            }
            that.navigation.closeNav();
            if ($url === that.ajaxUrl) {
                return false;
            }
            that.loader.classList.add('mdl-progress__indeterminate');
            document.body.classList.add('loading');
            that.ajaxUrl = $url;

            clearTimeout(that.ajaxTimer);

            that.ajaxTimer = setTimeout(function () {
                'use strict';

                that.r.open('POST', $url, true);
                that.r.send(that.d);

                that.r.onreadystatechange = function () {
                    'use strict';

                    if (that.r.readyState !== 4 || that.r.status !== 200) {
                        return;
                    }

                    that.ajaxContainer.innerHTML = that.r.responseText;

                    if ($pushState !== false) {
                        const title = that.ajaxContainer.querySelector('.ajax-content').getAttribute('data-title');
                        document.title = title;
                        history.pushState($url, title, $url);

                        ga('set', {page: $url, title: title});
                        ga('send', 'pageview');
                    }

                    document.querySelector('.mdl-layout__content').scrollTop = 0;

                    that.ajaxContainer.innerHTML = that.r.responseText;

                    that.initAjax(that.ajaxContainer);
                    that.loader.classList.remove('mdl-progress__indeterminate');
                    document.body.classList.remove('loading');
                };
            }, 500);
            return false;
        }

        if (!$container) {
            this.d.append('type', 868686);
        }

        const links = $container
            ? $container.querySelectorAll('a:not(.js-link):not([target="_blank"]):not([href^="http:"]):not([href^="#"]):not([href^="javascript:"])')
            : document.querySelectorAll('a:not(.js-link):not([target="_blank"]):not([href^="http:"]):not([href^="#"]):not([href^="javascript:"])');

        for (let i = 0; i < links.length; i++) {
            links[i].addEventListener('click', function (event) {
                const url = links[i].getAttribute('href');
                event.preventDefault();
                load(url);
            });
        }

        const linksU = $container
            ? $container.querySelectorAll('.load-uri')
            : document.querySelectorAll('.load-uri');

        for (let i = 0; i < linksU.length; i++) {
            linksU[i].addEventListener('click', function(event) {
                const url = linksU[i].getAttribute('data-uri');
                event.preventDefault();
                load(url);
            });
        }

        window.addEventListener('popstate', function (event) {
            if (event.state) {
                return load(location.pathname, false);
            }
            return true;
        });

    },
    initAjax: function ($container) {

        this.init($container);

        this.retinaImages.init($container);
        this.randomTeaser.init($container);

        this.backLink.init($container);

        this.hideHP($container);

        this.loadMore.init($container);
        this.loadFilter.init($container);
        this.slider.init($container);
        this.accordion.init($container);
        this.teamList.init($container);

        this.galleryDialog.init($container);

        this.msnry.init($container);

        if ($container) {
            componentHandler.upgradeDom();
        }
    },

    hideHP: function ($container) {
        'use strict';

        const links = $container
            ? $container.querySelectorAll('.js-hp')
            : document.querySelectorAll('.js-hp');

        for (let i = 0; i < links.length; i++) {
            links[i].style = 'display: none;';
            links[i].value = '';
        }
    }
};
